import React from 'react';
import { Phone } from 'lucide-react';

const StickyCallButton = () => {
  const phoneNumber = '+918679333354';

  return (
    <a
      href={`tel:${phoneNumber}`}
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Call us at +91 8679333354"
      title="Call Now"
    >
      <div
        className="flex items-center gap-3 px-6 py-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-105"
        style={{
          background: 'linear-gradient(135deg, #C9A96E 0%, #B8943F 100%)',
          boxShadow: '0 8px 30px rgba(201,169,110,0.45)',
          animation: 'pulse 2s infinite'
        }}
      >
        <Phone className="h-5 w-5 text-white" aria-hidden="true" />
        <span className="text-white font-semibold text-sm hidden sm:block" style={{ fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.3px' }}>
          Call Now
        </span>
      </div>
      <div className="absolute -top-12 right-0 bg-white px-4 py-2 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" aria-hidden="true">
        <p className="text-sm font-medium" style={{ color: '#C9A96E' }}>+91 8679 333 354</p>
      </div>
    </a>
  );
};

export default React.memo(StickyCallButton);
